import React, { useRef } from "react";
import styled from "styled-components";
import { FirebaseFile, makeId } from "sweet-global";
import ImageIcon from "sweet-web/components/icons/ImageIcon";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import { ItemTitle } from "sweet-web/components/universal/Text";
import { UploadFile } from "sweet-web/firebase";
import { colors } from "sweet-web/lib/styles";

const Wrapper = styled.div`
  align-self: left;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
`;

const HiddenInput = styled.input`
  display: none;
`;

type Props = {
  value: FirebaseFile;
  onChange: (value: FirebaseFile) => void;
  style?: object;
};
const FileInput: React.FC<Props> = props => {
  const inputRef = useRef(null);

  return (
    <Wrapper style={props.style}>
      <HiddenInput
        ref={inputRef}
        type="file"
        onChange={async e => {
          const id = makeId();
          const file = e.target.files[0];
          if (file) {
            const url = await UploadFile("venueMenus", file, id);
            props.onChange({
              url,
              id,
              type: file.type,
              name: file.name
            });
          }
        }}
      />

      <OutlineButton
        title={props.value ? props.value.name : "Upload File"}
        onClick={() => inputRef.current.click()}
      />
    </Wrapper>
  );
};
FileInput.defaultProps = {
  style: {}
};

export default FileInput;
